const reasons: Record<string, string> = {
  duplicate_message: 'Same recipient, shipment and message within the duplicate window',
  unverified_business_context: 'Business context could not be verified',
  recipient_changed: 'Recipient differs from the shipment at the time of the decision',
  assignment_archived: 'Assignment was archived',
  shipment_already_collected_or_returned: 'Collection reminder after a delivered or returned event',
  collection_deadline_passed: 'Collection deadline had passed',
  tariff_unknown: 'Destination tariff was unknown',
  destination_not_approved: 'Destination was outside the configured countries',
  global_minute_exceeded: 'Total SMS per minute exceeded the limit',
  company_minute_exceeded: 'Customer SMS per minute exceeded the limit',
  recipient_minute_exceeded: 'SMS to the same recipient per minute exceeded the limit',
  country_hour_exceeded: 'SMS to the destination country per hour exceeded the limit',
  global_day_exceeded: 'Total SMS in 24 hours exceeded the recorded volume allowance',
  company_day_exceeded: 'Customer SMS in 24 hours exceeded the shipment-adjusted allowance',
  global_day_usd_exceeded: 'Estimated spend in 24 hours exceeded the limit',
  company_day_usd_exceeded: 'Customer estimated spend in 24 hours exceeded the limit',
  max_segments_exceeded: 'Message segment count exceeded the limit',
}

export function protectionReasonLabel(reason: string, evidence: Record<string, unknown> = {}): string {
  const label = reasons[reason] || reason.replaceAll('_', ' ')
  const metric = reason.endsWith('_exceeded') ? reason.slice(0, -9) : ''
  const measurements = evidence.measurements as Record<string, unknown> | undefined
  const limits = evidence.limits as Record<string, unknown> | undefined
  if (metric && typeof measurements?.[metric] === 'number' && typeof limits?.[metric] === 'number') {
    const adaptive = evidence['adaptive_volume'] as Record<string, unknown> | undefined
    const scopes = adaptive?.scopes as Record<string, Record<string, unknown>> | undefined
    const scope = metric === 'global_day' ? scopes?.global : metric === 'company_day' ? scopes?.company : undefined
    const basis =
      scope &&
      typeof scope['sms_per_shipment'] === 'number' &&
      typeof scope['effective_daily_shipments'] === 'number' &&
      typeof scope.margin === 'number'
        ? `; baseline ${scope['sms_per_shipment'].toFixed(2)} SMS/shipment × ${scope['effective_daily_shipments'].toFixed(2)} daily shipment allowance × ${scope.margin} margin`
        : ''
    return `${label} (recorded: ${measurements[metric]}; limit: ${limits[metric]}${basis})`
  }
  if (reason === 'duplicate_message' && typeof evidence['duplicate_seconds'] === 'number') {
    return `${label} (${evidence['duplicate_seconds']} seconds)`
  }
  return label
}

export function protectionMoney(value: string | null): string {
  return value === null ? 'Unknown cost' : `${Number(value).toFixed(4)} USD`
}

export function protectionProviderLabel(status: string): string {
  return status === 'accepted' ? 'Accepted by Twilio (delivery unconfirmed)' : status
}

export function protectionLimitLabel(rule: string): string {
  const labels: Record<string, string> = {
    global_minute: 'All SMS / minute',
    company_minute: 'Per customer / minute',
    recipient_minute: 'Per recipient / minute',
    country_hour: 'Per country / hour',
    global_day: 'All SMS / 24 hours',
    company_day: 'Per customer / 24 hours',
    global_day_usd: 'Estimated spend / 24 hours (USD)',
    company_day_usd: 'Customer spend / 24 hours (USD)',
    max_segments: 'Segments per message',
  }
  return labels[rule] || rule.replaceAll('_', ' ')
}
